import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AIBackgroundEffects from './AIBackgroundEffects';
import API_CONFIG, { buildApiUrl } from '../config/api.config';
import './AdminLogin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [credentials, setCredentials] = useState({
    username: 'admin',
    password: 'AIVoice2024!'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!credentials.username || !credentials.password) {
      setError('Por favor ingresa usuario y contraseña');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(
        buildApiUrl(API_CONFIG.ENDPOINTS.ADMIN_LOGIN),
        credentials
      );

      if (response.data.success) {
        // Store token and admin info
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('adminInfo', JSON.stringify(response.data.admin));

        // Redirect to admin dashboard
        navigate('/admin/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(error.response?.data?.message || 'Error al iniciar sesión. Por favor intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <AIBackgroundEffects step={1} />
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h1>AI Voice Agent</h1>
          <h2>Portal de Administración</h2>
          <p>Gestión de Suscripciones de Agente de Voz</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">Usuario o Correo Electrónico</label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleInputChange}
              placeholder="Ingresa usuario o correo electrónico"
              autoComplete="username"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleInputChange}
              placeholder="Ingresa contraseña"
              autoComplete="current-password"
              required
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>

        <div className="login-footer">
          <p className="security-note">
            🔒 Acceso seguro solo para administradores
          </p>
          <div className="dev-credentials">
            <strong>🔑 Credenciales de Desarrollo:</strong><br />
            <div className="credentials-info">
              Usuario: <code>admin</code><br />
              Contraseña: <code>AIVoice2024!</code>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;